export const deriveStatus = (test) => {
  if (!test.is_published) return 'draft';
  if (test.assigned_count > 0 && test.completed_count >= test.assigned_count) return 'completed';
  if (test.scheduled_at && new Date(test.scheduled_at) > new Date()) return 'scheduled';
  return 'active';
};

export const statusMeta = (status) => {
  switch (status) {
    case 'draft':
      return { label: 'Draft', color: '#64748b', bg: '#f1f5f9' }; // Slate
    case 'scheduled':
      return { label: 'Scheduled', color: '#eab308', bg: '#fef9c3' }; // Yellow
    case 'active':
      return { label: 'Active', color: '#22c55e', bg: '#dcfce3' }; // Green
    case 'completed':
      return { label: 'Completed', color: '#3b82f6', bg: '#dbeafe' }; // Blue
    default:
      return { label: 'Unknown', color: '#94a3b8', bg: '#f8fafc' };
  }
};

export const canEdit = (test) => {
  return (test.completed_count || 0) === 0;
};

export const canDelete = (test) => {
  return (test.completed_count || 0) === 0;
};
